var Fader = /** @class */ (function () {
    function Fader(fader) {
        this.className = 'c-fader';
        this.horizontalClassName = this.className + '--horizontal';
        this.leftClassName = this.className + '--left';
        this.topClassName = this.className + '--top';
        this.resizeTimeout = 0;
        this.scrollTimeout = 0;
        this.fader = fader;
        this.isHorizontal = this.isHorizontalFader();
        this.isRelatedToRightElement = this.isRelatedToRightSibling();
        this.faderHeight = this.fader.offsetHeight;
        this.faderSibling = this.setSibling();
        this.faderWidth = this.fader.offsetWidth;
        this.bindEvents();
        //this.setFaderStyle(); only needed if sibling container is absolute
        this.showOrHideFader();
    }
    Fader.prototype.bindEvents = function () {
        var _this = this;
        this.faderSibling.addEventListener("scroll", function () {
            _this.hide();
            window.clearTimeout(_this.scrollTimeout);
            _this.scrollTimeout = window.setTimeout(function () {
                _this.showOrHideFader();
            }, 400);
        });
        window.addEventListener('resize', function () { _this.onResize(); });
    };
    Fader.prototype.onResize = function () {
        var _this = this;
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(function () {
            _this.showOrHideFader();
        }, 400);
    };
    Fader.prototype.hasScrollbar = function () {
        var hasVerticalScrollbar = this.faderSibling.scrollHeight > this.faderSibling.clientHeight;
        var hasHorizintalScrollbar = this.faderSibling.scrollWidth > this.faderSibling.clientWidth;
        return this.isHorizontal ? hasHorizintalScrollbar : hasVerticalScrollbar;
    };
    Fader.prototype.hide = function () {
        this.fader.style.opacity = '0';
    };
    Fader.prototype.isActive = function () {
        return (!this.isRelatedToRightElement && this.isScrollStart()) || (this.isRelatedToRightElement && this.isScrollEnd());
    };
    Fader.prototype.isHorizontalFader = function () {
        return this.fader.className.indexOf(this.horizontalClassName) > -1;
    };
    Fader.prototype.isRelatedToRightSibling = function () {
        return this.fader.className.indexOf(this.leftClassName) > -1 ||
            this.fader.className.indexOf(this.topClassName) > -1;
    };
    Fader.prototype.isScrollEnd = function () {
        if (this.isHorizontal) {
            return Math.abs(this.faderSibling.scrollWidth - this.faderSibling.scrollLeft - this.faderSibling.clientWidth) < 1;
        }
        else {
            return Math.abs(this.faderSibling.scrollHeight - this.faderSibling.scrollTop - this.faderSibling.clientHeight) < 1;
        }
    };
    Fader.prototype.isScrollStart = function () {
        if (this.isHorizontal) {
            return this.faderSibling.scrollLeft === 0;
        }
        else {
            return this.faderSibling.scrollTop === 0;
        }
    };
    Fader.prototype.setFaderStyle = function () {
        var previousSiblingHeight = this.faderSibling.offsetHeight;
        if (!this.isHorizontal) {
            this.fader.style.top = previousSiblingHeight - this.faderHeight + this.faderSibling.offsetTop + 'px';
        }
    };
    Fader.prototype.setSibling = function () {
        if (this.isRelatedToRightElement) {
            return this.fader.nextElementSibling;
        }
        else {
            return this.fader.previousElementSibling;
        }
    };
    Fader.prototype.show = function () {
        this.fader.style.opacity = '1';
    };
    Fader.prototype.showOrHideFader = function () {
        if (this.hasScrollbar()) {
            if (this.isActive()) {
                this.show();
            }
            else {
                this.hide();
            }
        }
        else {
            this.hide();
        }
    };
    return Fader;
}());
export default Fader;
;
